module.exports = __webpack_public_path__ + "static/media/share-white.a109dbb3.svg";